module.exports = __webpack_public_path__ + "img/attachment-zip.cba8f750.svg";